var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"profile_section"},[_c('v-container',[_c('div',{staticClass:"__bread mb-5"},[_c('v-breadcrumbs',{attrs:{"items":_vm.Bread}})],1),_c('Profile')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }